import { Box, Button, Stack, Typography } from "@mui/material";
import ButtonWithUnderline from "../../ButtonWithUnderline";
import { l_footer } from "../locales";
import { LocalizedLink } from "../../../LocalizedLink";

const CollaborationSection = () => {
  return (
    <Stack
      sx={{
        flexDirection: { lg: "row", xs: "column" },
        alignItems: "center",
        gap: { lg: "24px", md: "48px", xs: "32px" },
        marginBottom: { lg: "112px", xs: "64px" },
      }}
    >
      <Box sx={{ maxWidth: { lg: "58%", xs: "100%" } }}>
        <Typography
          sx={{
            color: "white",
            fontSize: { md: "64px", xs: "32px" },
            lineHeight: { md: "88px", xs: "32px" },
            fontWeight: 700,
            maxWidth: { lg: "70%", xs: "100%" },
            marginBottom: "24px",
          }}
        >
          {l_footer("title.title")}
        </Typography>
        <Typography
          sx={{
            color: "rgba(255, 255, 255, 0.88)",
            fontSize: { md: "20px", xs: "16px" },
            lineHeight: { md: "28px", xs: "20px" },
          }}
        >
          {l_footer("title.subtitle")}
        </Typography>
      </Box>
      <Box
        sx={{
          marginRight: { xs: "auto", lg: undefined },
          margin: { lg: "auto", xs: undefined },
        }}
      >
        <LocalizedLink to={"/contacts"} style={{ textDecoration: "none" }}>
          <Button
            disableRipple
            sx={{
              backgroundColor: "white",
              borderRadius: "64px",
              paddingX: { xl: "64px", xs: "24px" },
              textDecoration: "none !important",
              ":hover": {
                backgroundColor: "rgba(255, 255, 255, 0.94)",
              },
            }}
          >
            <Typography
              sx={{
                fontSize: { lg: "60px", md: "44px", xs: "24px" },
                color: "#1A2045",
                fontWeight: 600,
                textDecoration: "none !important",
                textTransform: "none",
              }}
            >
              {l_footer("title.button")}
            </Typography>
          </Button>
        </LocalizedLink>
        {/* <ButtonWithUnderline
          defaultUnderlined
          link="/contacts"
          lineStyle={{
            backgroundColor: "#fff",
            height: { md: "4px", xs: "2px" },
          }}
          sx={{ width: "fit-content" }}
        >
          <Typography
            sx={{
              fontSize: { lg: "64px", md: "48px", xs: "24px" },
              color: "#fff",
              fontWeight: 700,
            }}
          >
            {l_footer("title.button")}
          </Typography>
        </ButtonWithUnderline> */}
      </Box>
    </Stack>
  );
};

export default CollaborationSection;
